import './index.css';
import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import AcUnitIcon from '@material-ui/icons/AcUnit';
import IconButton from '@material-ui/core/IconButton';
import AccountCircleOutlinedIcon from '@material-ui/icons/AccountCircleOutlined';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { useTheme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import { Menu, MenuItem, Popover } from '@material-ui/core';
import LogoutScreen from '../../auth/SignInScreen/LogoutScreen';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import {
  ADD_USER_TEENYEBEANS_PORTAL_ROUTE_PREFIX,
  AFFILIATED_LEAD_CONVERTED_MODULE_ROUTE,
  AFFILIATED_LEAD_GENERATED_MODULE_ROUTE,
  AFFILIATED_MESSAGE_MODULE_ROUTE,
  AFFILIATED_ROUTE_PREFIX,
  AKADEMY_CLASSES_ROUTE,
  AKADEMY_LANGUAGES_ROUTE,
  AKADEMY_PROGRAMMES_ROUTE,
  AKADEMY_ROUTE,
  AKADEMY_SCHOOLS_ROUTE,
  AKADEMY_USERS_ROUTE,
  AKADEMY_SCHOOL_MEMBERS_ROUTE,
  CREATE_DISCOUNT_ROUTE,
  DISCOVERY_FINANCE_ROUTE,
  FEATURED_SCHOOL_MODULE_ROUTE,
  JFT_FINANCE_ROUTE,
  LAUNCH_MODULE_ROUTE,
  MGMENT_FINANCE_ROUTE,
  PARTIAL_ROLLOUT_MODULE_ROUTE,
  TB_PORTAL_SCHOOL_DETAILS_ROUTE,
  TB_PORTAL_SCHOOL_UPDATE_ROUTE,
  TB_PORTAL_WEBSITE_ROUTE,
  TEENYEBEANS_PORTAL_ROUTE_PREFIX,
  AKADEMY_CURRICULUM_FRAMEWORKS_ROUTE,
  AKADEMY_CURRICULUM_NODES_ROUTE,
  AKADEMY_CURRICULUM_AGE_GROUPS_ROUTE,
  AKADEMY_CURRICULUM_RATING_SCALES_ROUTE,
  AKADEMY_CURRICULUM_SUGGESTIONS_ROUTE,
  AKADEMY_INDICATOR_STATUTORIES_ROUTE,
  AKADEMY_TALKTIME_PLANS_ROUTE,
  AKADEMY_TALKTIME_CONSUMPTION_ROUTE,
  AKADEMY_AI_ASSIST_CONSUMPTION_ROUTE,
  BUZZONE_SCHOOLS_ROUTE,
  BUZZONE_ROUTE,
  BUZZONE_STAFFS_ROUTE,
  BUZZONE_STUDENTS_ROUTE,
  AKADEMY_WIDGET_ROUTE,
  AKADEMY_WIDGET_CUSTOMIZATION_ROUTE,
  AKADEMY_ANALYTICS_ROUTE,
  CHANGE_PASSWORD_ROUTE,
  MGMENT_DASHBOARD_ROUTE,
} from '../../routes/routes';
import { useSelector } from 'react-redux';
import useScopes from '../../hooks/useScopes';

const useStyles = makeStyles((theme) => ({
  root: {
    background: 'white',
  },
  headerBoxStyle: {
    height: 80,
  },
  input: {
    width: '100%',
    fontSize: '13.5px',
  },
  h2: {
    color: '#FE4500',
  },
  demo1: {
    backgroundColor: '#FFF6F2',
    height: '3rem',
    padding: '0 4%',
  },
  demo2: {
    backgroundColor: '#2e1534',
  },
  navicons: {
    margin: '1.3rem 3rem 0 0',
    opacity: '0.5',
    float: 'right',
    display: 'flex',
  },
  naviconspace: {
    marginLeft: '2rem',
    cursor: 'pointer',
  },
  searchBoxStyle: {
    backgroundColor: theme.palette.buzzBackground,
    height: 44,
    maxWidth: 422,
  },
  navBarStyle: {
    background: '#FFF6F2',
  },
  details: {
    color: '#000',
    textDecoration: 'none',
  },
  underLine: {
    textDecoration: 'underline',
    color: theme.palette.primary.main,
    '&:hover': {
      cursor: 'pointer',
    },
  },
  hover: {
    '&:hover': {
      color: theme.palette.primary.main,
      cursor: 'pointer',
    },
  },
}));

const AntTabs = withStyles({
  root: {
    borderBottom: '1px solid #e8e8e8',
  },
  indicator: {
    backgroundColor: '#FE4500',
  },
})(Tabs);

const AntTab = withStyles((theme) => ({
  root: {
    textTransform: 'none',
    minWidth: 72,
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(2),
    '&:hover': {
      color: '#FE4500',
      opacity: 1,
    },
    '&$selected': {
      backgroundColor: '#ffffff',
      color: '#FE4500',
      fontWeight: '600',
      fontSize: '16px',
    },
    '&:focus': {
      color: '#FE4500',
      backgroundColor: 'white',
      transitionProperty: 'background-color',
      transitionDuration: '1s',
    },
  },
  selected: {},
}))((props) => <Tab disableRipple {...props} />);

export default function Nav(props) {
  const theme = useTheme();
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const { access } = useScopes();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const id = open ? 'logout-popover' : undefined;
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const { pathname } = useLocation();
  const [anchorElFinMenu, setAnchorElFinMenu] = React.useState(null);
  const [anchorElLaunchMenu, setAnchorElLaunchMenu] = React.useState(null);

  const { moduleAccess } = useSelector(({ signInReducer }) => {
    return {
      moduleAccess: signInReducer.me
        ? signInReducer.me.data
          ? signInReducer.me.data.role
          : []
        : [],
    };
  });

  useEffect(() => {
    switch (pathname) {
      case '/approval-management':
      case '/approval-management/ManagementAppApproval':
      case '/approval-management/DiscoveryAppApproval':
      case '/approval-management/jft-approval':
      case '/approval-management/confirm-admissions':
      case '/approval-management/set-up-payments':
      case '/approval-management/DiscoveryAppApproval/create':
      case '/approval-management/gift-vouchers/create':
      case '/approval-management/gift-vouchers/approve-programs':
      case '/approval-management/kyc-approval':
      case CREATE_DISCOUNT_ROUTE:
      case '/approval-management/story-approval':
      case '/approval-management/update-story':
      case '/approval-management/create-story':
      case '/approval-management/view-details':
        setValue(1);
        break;
      case '/finance-management':
      case '/finance-management/management-app-finance':
      case '/finance-management/discovery-app-finance':
      case '/finance-management/jft-finance':
        setValue(2);
        break;
      case '/user-management':
      case '/user-management/management-app-user':
      case '/user-management/discovery-app-user':
      case '/user-management/jft-user':
      case '/user-management/bcc-user':
      case '/user-management/add-user':
      case CHANGE_PASSWORD_ROUTE:
        setValue(3);
        break;
      case 'atheneum':
      case '/atheneum/programs':
      case '/atheneum/courses':
      case '/atheneum/cart':
      case '/atheneum/offer':
      case '/atheneum/user':
      case '/atheneum/orders':
        setValue(4);
        break;
      case 'launch-management':
      case '/launch-management':
      case '/launch-management/partial-rollout':
      case '/launch-management/launch':
      case '/launch-management/featured-school':
        setValue(5);
        break;
      case AKADEMY_ROUTE:
      case AKADEMY_SCHOOLS_ROUTE:
      case AKADEMY_USERS_ROUTE:
      case AKADEMY_SCHOOL_MEMBERS_ROUTE:
      case AKADEMY_CLASSES_ROUTE:
      case AKADEMY_LANGUAGES_ROUTE:
      case AKADEMY_PROGRAMMES_ROUTE:
      case AKADEMY_TALKTIME_PLANS_ROUTE:
      case AKADEMY_TALKTIME_CONSUMPTION_ROUTE:
      case AKADEMY_AI_ASSIST_CONSUMPTION_ROUTE:
      case AKADEMY_CURRICULUM_FRAMEWORKS_ROUTE:
      case AKADEMY_CURRICULUM_NODES_ROUTE:
      case AKADEMY_CURRICULUM_RATING_SCALES_ROUTE:
      case AKADEMY_CURRICULUM_AGE_GROUPS_ROUTE:
      case AKADEMY_CURRICULUM_SUGGESTIONS_ROUTE:
      case AKADEMY_INDICATOR_STATUTORIES_ROUTE:
      case AKADEMY_WIDGET_ROUTE:
      case AKADEMY_WIDGET_CUSTOMIZATION_ROUTE:
      case AKADEMY_ANALYTICS_ROUTE:
        setValue(6);
        break;
      case AFFILIATED_ROUTE_PREFIX:
      case AFFILIATED_LEAD_GENERATED_MODULE_ROUTE:
      case AFFILIATED_LEAD_CONVERTED_MODULE_ROUTE:
      case AFFILIATED_MESSAGE_MODULE_ROUTE:
        setValue(7);
        break;
      case TEENYEBEANS_PORTAL_ROUTE_PREFIX:
      case TB_PORTAL_SCHOOL_DETAILS_ROUTE:
      case TB_PORTAL_SCHOOL_UPDATE_ROUTE:
      case ADD_USER_TEENYEBEANS_PORTAL_ROUTE_PREFIX:
      case TB_PORTAL_WEBSITE_ROUTE:
        setValue(8);
        break;
      case BUZZONE_ROUTE:
      case BUZZONE_SCHOOLS_ROUTE:
      case BUZZONE_STAFFS_ROUTE:
      case BUZZONE_STUDENTS_ROUTE:
        setValue(9);
        break;
      default:
        setValue(0);
    }
  }, [pathname]);

  const finRouteOptions = [
    {
      name: 'Management App',
      path: MGMENT_FINANCE_ROUTE,
      scope: 'approval:management:readWrite',
    },
    {
      name: 'Discovery App',
      path: DISCOVERY_FINANCE_ROUTE,
      scope: 'approval:discovery:readWrite',
    },
    { name: 'JFT', path: JFT_FINANCE_ROUTE, scope: '' },
  ];

  const launchRouteOptions = [
    {
      name: 'Partial Rollout',
      path: PARTIAL_ROLLOUT_MODULE_ROUTE,
      scope: 'approval:management:readWrite',
    },
    {
      name: 'Launch Pincodes',
      path: LAUNCH_MODULE_ROUTE,
      scope: 'approval:discovery:readWrite',
    },
    {
      name: 'Featured School',
      path: FEATURED_SCHOOL_MODULE_ROUTE,
      scope: 'approval:management:readWrite',
    },
  ];

  const handleClickFinMenu = (event) => {
    setAnchorElFinMenu(event.currentTarget);
  };

  const handleCloseFinMenu = () => {
    setAnchorElFinMenu(null);
  };
  const handleClickLaunchMenu = (event) => {
    setAnchorElLaunchMenu(event.currentTarget);
  };

  const handleCloseLaunchMenu = () => {
    setAnchorElLaunchMenu(null);
  };
  return (
    <>
      <Box className={classes.root}>
        <Box
          display={'flex'}
          alignItems={'center'}
          className={classes.headerBoxStyle}>
          <Box flex={1} pl={4}>
            <Box
              display={'flex'}
              alignItems={'center'}
              justifyContent={'center'}>
              <Box mr={1}>
                <AcUnitIcon color={'primary'} fontSize="large" />
              </Box>
              <Typography variant="h4">
                <Box
                  width={300}
                  fontWeight="fontWeightBold"
                  color={theme.palette.primary.main}>
                  Buzz Control Center
                </Box>
              </Typography>
            </Box>
          </Box>
          <Box flex={3} />
          <Box
            flex={3}
            display={'flex'}
            alignItems={'right'}
            justifyContent={'right'}>
            <Box display={'flex'} alignItems={'between'}>
              <IconButton>
                <AccountCircleOutlinedIcon />
              </IconButton>
              <IconButton onClick={handleClick}>
                <ExpandMoreIcon />
              </IconButton>
            </Box>
          </Box>
        </Box>
      </Box>
      <div>
        <Paper className={classes.navBarStyle} elevation={3}>
          <AntTabs
            value={value}
            onChange={handleChange}
            aria-label="ant example">
            <AntTab
              component={Link}
              to={MGMENT_DASHBOARD_ROUTE}
              label="Dashboard"
            />
            {moduleAccess.includes('bccSchoolAdmin') ||
            moduleAccess.includes('bccDiscoveryAdmin') ||
            moduleAccess.includes('bccSuperAdmin') ? (
              <AntTab
                component={Link}
                to={
                  moduleAccess.includes('bccDiscoveryAdmin')
                    ? '/approval-management/DiscoveryAppApproval'
                    : '/approval-management'
                }
                label="Approval Management"
              />
            ) : null}

            {moduleAccess.includes('bccSchoolAdmin') ||
            moduleAccess.includes('bccDiscoveryAdmin') ||
            moduleAccess.includes('bccSuperAdmin') ? (
              <AntTab
                component={Link}
                to={
                  moduleAccess.includes('bccDiscoveryAdmin')
                    ? '/finance-management/discovery-app-finance'
                    : '/finance-management'
                }
                label={
                  <Box display="flex" alignItems="center" mr={-1}>
                    <Box mr={0}>Finance Management</Box>
                    <IconButton
                      aria-label="more"
                      aria-controls="long-menu"
                      aria-haspopup="true"
                      onMouseOver={handleClickFinMenu}>
                      <ExpandMoreIcon color={value === 2 ? 'primary' : ''} />
                    </IconButton>
                  </Box>
                }
              />
            ) : null}
            {moduleAccess.includes('bccSuperAdmin') ? (
              <AntTab
                component={Link}
                to={
                  moduleAccess.includes('bccDiscoveryAdmin')
                    ? '/user-management/discovery-app-user'
                    : '/user-management'
                }
                label="User Management"
              />
            ) : null}
            {moduleAccess.includes('bccAtheneumAdmin') ||
            moduleAccess.includes('bccSuperAdmin') ? (
              <AntTab
                component={Link}
                to={'/atheneum/programs'}
                label="Atheneum"
              />
            ) : null}
            {moduleAccess.includes('bccSchoolAdmin') ||
            moduleAccess.includes('bccDiscoveryAdmin') ||
            moduleAccess.includes('bccSuperAdmin') ? (
              <AntTab
                component={Link}
                to={
                  moduleAccess.includes('bccDiscoveryAdmin')
                    ? '/launch-management/launch'
                    : '/launch-management/partial-rollout'
                }
                label={
                  <Box display="flex" alignItems="center" mr={-1}>
                    <Box mr={0}>Launch Management</Box>
                    <IconButton
                      aria-label="more"
                      aria-controls="long-menu"
                      aria-haspopup="true"
                      onMouseOver={handleClickLaunchMenu}>
                      <ExpandMoreIcon color={value === 2 ? 'primary' : ''} />
                    </IconButton>
                  </Box>
                }
              />
            ) : null}
            {moduleAccess.includes('bccAkademyAdmin') ||
            moduleAccess.includes('bccSuperAdmin') ? (
              <AntTab
                component={Link}
                to={AKADEMY_SCHOOLS_ROUTE}
                label="Akadmy"
              />
            ) : null}
            {moduleAccess.includes('bccAffiliateAdmin') ||
            moduleAccess.includes('bccSuperAdmin') ? (
              <AntTab
                component={Link}
                to={AFFILIATED_LEAD_GENERATED_MODULE_ROUTE}
                label="Affiliate"
              />
            ) : null}
            {moduleAccess.includes('bccTeenybeansAdmin') ||
            moduleAccess.includes('bccSuperAdmin') ? (
              <AntTab
                component={Link}
                to={TEENYEBEANS_PORTAL_ROUTE_PREFIX}
                label="Teeny Beans Portal"
              />
            ) : null}
            {moduleAccess.includes('bccBuzzOneAdmin') ||
            moduleAccess.includes('bccSuperAdmin') ? (
              <AntTab
                component={Link}
                to={BUZZONE_SCHOOLS_ROUTE}
                label="Buzz One"
              />
            ) : null}
          </AntTabs>
          <Typography className={classes.padding} />
          <Box>
            <Menu
              style={{ top: '8px', left: '-85px' }}
              elevation={4}
              getContentAnchorEl={null}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
              id="simple-menu"
              anchorEl={anchorElFinMenu}
              keepMounted
              open={Boolean(anchorElFinMenu)}
              onClose={handleCloseFinMenu}>
              {finRouteOptions.map((option, idx) => (
                <>
                  {moduleAccess === 'bccSuperAdmin' ||
                  access({
                    mode: 'allOf',
                    scope: [option.scope],
                  }) ? (
                    <MenuItem
                      component={Link}
                      to={`${option.path}`}
                      onClick={handleCloseFinMenu}
                      key={idx}>
                      <Box className={classes.details} width={190}>
                        {option.name}
                      </Box>
                    </MenuItem>
                  ) : null}
                </>
              ))}
            </Menu>
            <Menu
              style={{ top: '8px', left: '-85px' }}
              elevation={4}
              getContentAnchorEl={null}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
              id="simple-menu"
              anchorEl={anchorElLaunchMenu}
              keepMounted
              open={Boolean(anchorElLaunchMenu)}
              onClose={handleCloseLaunchMenu}>
              {launchRouteOptions.map((option, idx) => (
                <>
                  {moduleAccess === 'bccSuperAdmin' ||
                  access({
                    mode: 'allOf',
                    scope: [option.scope],
                  }) ? (
                    <MenuItem
                      component={Link}
                      to={`${option.path}`}
                      onClick={handleCloseLaunchMenu}
                      key={idx}>
                      <Box className={classes.details} width={190}>
                        {option.name}
                      </Box>
                    </MenuItem>
                  ) : null}
                </>
              ))}
            </Menu>
          </Box>
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}>
            <LogoutScreen>
              <Button endIcon={<ExitToAppIcon />}>
                <Typography>Logout</Typography>
              </Button>
            </LogoutScreen>
          </Popover>
        </Paper>
      </div>
      {props.children}
    </>
  );
}
